// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignInIndexRouteImport } from './routes/sign-in/index'
import { Route as SignInSplatRouteImport } from './routes/sign-in/$'
import { Route as DemoIndexRouteImport } from './routes/demo/index'
import { Route as DemoUuidRouteImport } from './routes/demo/$uuid'
import { Route as AuthenticatedStonelogRouteImport } from './routes/_authenticated/stonelog'
import { Route as AuthenticatedSelectModuleRouteImport } from './routes/_authenticated/select-module'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedStonelogIndexRouteImport } from './routes/_authenticated/stonelog/index'
import { Route as AuthenticatedStonelogSelectLogRouteImport } from './routes/_authenticated/stonelog/select-log'
import { Route as AuthenticatedStonelogDashboardRouteImport } from './routes/_authenticated/stonelog/dashboard'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminStaffRouteImport } from './routes/_authenticated/admin/staff'
import { Route as AuthenticatedAdminFieldLibraryRouteImport } from './routes/_authenticated/admin/field-library'
import { Route as AuthenticatedAdminFeatureFlagsRouteImport } from './routes/_authenticated/admin/feature-flags'
import { Route as AuthenticatedAdminDemoSessionsRouteImport } from './routes/_authenticated/admin/demo-sessions'
import { Route as AuthenticatedStonelogExceptionsIndexRouteImport } from './routes/_authenticated/stonelog/exceptions/index'
import { Route as AuthenticatedStonelogExceptionsNewRouteImport } from './routes/_authenticated/stonelog/exceptions/new'
import { Route as AuthenticatedStonelogExceptionsExceptionIdRouteImport } from './routes/_authenticated/stonelog/exceptions/$exceptionId'
import { Route as AuthenticatedAdminTenantsIndexRouteImport } from './routes/_authenticated/admin/tenants.index'
import { Route as AuthenticatedAdminTenantsOrgIdRouteImport } from './routes/_authenticated/admin/tenants/$orgId'
import { Route as AuthenticatedAdminTenantsOrgIdIndexRouteImport } from './routes/_authenticated/admin/tenants/$orgId.index'
import { Route as AuthenticatedAdminTenantsOrgIdUsersRouteImport } from './routes/_authenticated/admin/tenants/$orgId.users'
import { Route as AuthenticatedAdminTenantsOrgIdReferenceDataRouteImport } from './routes/_authenticated/admin/tenants/$orgId.reference-data'
import { Route as AuthenticatedAdminTenantsOrgIdModulesRouteImport } from './routes/_authenticated/admin/tenants/$orgId.modules'
import { Route as AuthenticatedAdminTenantsOrgIdFieldsRouteImport } from './routes/_authenticated/admin/tenants/$orgId.fields'
import { Route as AuthenticatedAdminTenantsOrgIdDepartmentsRouteImport } from './routes/_authenticated/admin/tenants/$orgId.departments'
import { Route as AuthenticatedAdminTenantsOrgIdBillingRouteImport } from './routes/_authenticated/admin/tenants/$orgId.billing'

const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SignInIndexRoute = SignInIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SignInRoute
          })
const SignInSplatRoute = SignInSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => SignInRoute
          })
const DemoIndexRoute = DemoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DemoRoute
          })
const DemoUuidRoute = DemoUuidRouteImport.update({
            id: '/$uuid',path: '/$uuid',getParentRoute: () => DemoRoute
          })
const AuthenticatedStonelogRoute = AuthenticatedStonelogRouteImport.update({
            id: '/stonelog',path: '/stonelog',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSelectModuleRoute = AuthenticatedSelectModuleRouteImport.update({
            id: '/select-module',path: '/select-module',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedStonelogIndexRoute = AuthenticatedStonelogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedStonelogRoute
          })
const AuthenticatedStonelogSelectLogRoute = AuthenticatedStonelogSelectLogRouteImport.update({
            id: '/select-log',path: '/select-log',getParentRoute: () => AuthenticatedStonelogRoute
          })
const AuthenticatedStonelogDashboardRoute = AuthenticatedStonelogDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedStonelogRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminStaffRoute = AuthenticatedAdminStaffRouteImport.update({
            id: '/staff',path: '/staff',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFieldLibraryRoute = AuthenticatedAdminFieldLibraryRouteImport.update({
            id: '/field-library',path: '/field-library',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFeatureFlagsRoute = AuthenticatedAdminFeatureFlagsRouteImport.update({
            id: '/feature-flags',path: '/feature-flags',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDemoSessionsRoute = AuthenticatedAdminDemoSessionsRouteImport.update({
            id: '/demo-sessions',path: '/demo-sessions',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedStonelogExceptionsIndexRoute = AuthenticatedStonelogExceptionsIndexRouteImport.update({
            id: '/exceptions/',path: '/exceptions/',getParentRoute: () => AuthenticatedStonelogRoute
          })
const AuthenticatedStonelogExceptionsNewRoute = AuthenticatedStonelogExceptionsNewRouteImport.update({
            id: '/exceptions/new',path: '/exceptions/new',getParentRoute: () => AuthenticatedStonelogRoute
          })
const AuthenticatedStonelogExceptionsExceptionIdRoute = AuthenticatedStonelogExceptionsExceptionIdRouteImport.update({
            id: '/exceptions/$exceptionId',path: '/exceptions/$exceptionId',getParentRoute: () => AuthenticatedStonelogRoute
          })
const AuthenticatedAdminTenantsIndexRoute = AuthenticatedAdminTenantsIndexRouteImport.update({
            id: '/tenants/',path: '/tenants/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTenantsOrgIdRoute = AuthenticatedAdminTenantsOrgIdRouteImport.update({
            id: '/tenants/$orgId',path: '/tenants/$orgId',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTenantsOrgIdIndexRoute = AuthenticatedAdminTenantsOrgIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminTenantsOrgIdRoute
          })
const AuthenticatedAdminTenantsOrgIdUsersRoute = AuthenticatedAdminTenantsOrgIdUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminTenantsOrgIdRoute
          })
const AuthenticatedAdminTenantsOrgIdReferenceDataRoute = AuthenticatedAdminTenantsOrgIdReferenceDataRouteImport.update({
            id: '/reference-data',path: '/reference-data',getParentRoute: () => AuthenticatedAdminTenantsOrgIdRoute
          })
const AuthenticatedAdminTenantsOrgIdModulesRoute = AuthenticatedAdminTenantsOrgIdModulesRouteImport.update({
            id: '/modules',path: '/modules',getParentRoute: () => AuthenticatedAdminTenantsOrgIdRoute
          })
const AuthenticatedAdminTenantsOrgIdFieldsRoute = AuthenticatedAdminTenantsOrgIdFieldsRouteImport.update({
            id: '/fields',path: '/fields',getParentRoute: () => AuthenticatedAdminTenantsOrgIdRoute
          })
const AuthenticatedAdminTenantsOrgIdDepartmentsRoute = AuthenticatedAdminTenantsOrgIdDepartmentsRouteImport.update({
            id: '/departments',path: '/departments',getParentRoute: () => AuthenticatedAdminTenantsOrgIdRoute
          })
const AuthenticatedAdminTenantsOrgIdBillingRoute = AuthenticatedAdminTenantsOrgIdBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedAdminTenantsOrgIdRoute
          })





const AuthenticatedAdminTenantsOrgIdRouteChildren = {
  AuthenticatedAdminTenantsOrgIdBillingRoute: AuthenticatedAdminTenantsOrgIdBillingRoute,AuthenticatedAdminTenantsOrgIdDepartmentsRoute: AuthenticatedAdminTenantsOrgIdDepartmentsRoute,AuthenticatedAdminTenantsOrgIdFieldsRoute: AuthenticatedAdminTenantsOrgIdFieldsRoute,AuthenticatedAdminTenantsOrgIdModulesRoute: AuthenticatedAdminTenantsOrgIdModulesRoute,AuthenticatedAdminTenantsOrgIdReferenceDataRoute: AuthenticatedAdminTenantsOrgIdReferenceDataRoute,AuthenticatedAdminTenantsOrgIdUsersRoute: AuthenticatedAdminTenantsOrgIdUsersRoute,AuthenticatedAdminTenantsOrgIdIndexRoute: AuthenticatedAdminTenantsOrgIdIndexRoute
}

const AuthenticatedAdminTenantsOrgIdRouteWithChildren = AuthenticatedAdminTenantsOrgIdRoute._addFileChildren(AuthenticatedAdminTenantsOrgIdRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminDemoSessionsRoute: AuthenticatedAdminDemoSessionsRoute,AuthenticatedAdminFeatureFlagsRoute: AuthenticatedAdminFeatureFlagsRoute,AuthenticatedAdminFieldLibraryRoute: AuthenticatedAdminFieldLibraryRoute,AuthenticatedAdminStaffRoute: AuthenticatedAdminStaffRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminTenantsOrgIdRoute: AuthenticatedAdminTenantsOrgIdRouteWithChildren,AuthenticatedAdminTenantsIndexRoute: AuthenticatedAdminTenantsIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedStonelogRouteChildren = {
  AuthenticatedStonelogDashboardRoute: AuthenticatedStonelogDashboardRoute,AuthenticatedStonelogSelectLogRoute: AuthenticatedStonelogSelectLogRoute,AuthenticatedStonelogIndexRoute: AuthenticatedStonelogIndexRoute,AuthenticatedStonelogExceptionsExceptionIdRoute: AuthenticatedStonelogExceptionsExceptionIdRoute,AuthenticatedStonelogExceptionsNewRoute: AuthenticatedStonelogExceptionsNewRoute,AuthenticatedStonelogExceptionsIndexRoute: AuthenticatedStonelogExceptionsIndexRoute
}

const AuthenticatedStonelogRouteWithChildren = AuthenticatedStonelogRoute._addFileChildren(AuthenticatedStonelogRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedSelectModuleRoute: AuthenticatedSelectModuleRoute,AuthenticatedStonelogRoute: AuthenticatedStonelogRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const DemoRouteChildren = {
  DemoUuidRoute: DemoUuidRoute,DemoIndexRoute: DemoIndexRoute
}

const DemoRouteWithChildren = DemoRoute._addFileChildren(DemoRouteChildren)




const SignInRouteChildren = {
  SignInSplatRoute: SignInSplatRoute,SignInIndexRoute: SignInIndexRoute
}

const SignInRouteWithChildren = SignInRoute._addFileChildren(SignInRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,DemoRoute: DemoRouteWithChildren,SignInRoute: SignInRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)